import { Link } from 'react-router-dom';
import { useEvents } from '../hooks/use-events';
import { formatDate, formatDateTime } from '../lib/format';

export function EventListPage() {
  const events = useEvents(false);

  return (
    <div className="px-4 py-4 space-y-3">
      <header className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Events</h1>
        <Link
          to="/app/events/new"
          className="rounded-md bg-brand-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-brand-700"
        >
          + Neu
        </Link>
      </header>

      {events.isLoading ? (
        <p className="py-12 text-center text-sm text-slate-400">Lädt …</p>
      ) : events.error ? (
        <p className="py-12 text-center text-sm text-rose-400">
          Fehler beim Laden
        </p>
      ) : events.data && events.data.length > 0 ? (
        <ul className="space-y-2">
          {events.data.map((e) => {
            const isPast = new Date(e.startAt).getTime() < Date.now();
            return (
              <li key={e.id}>
                <Link
                  to={`/app/events/${e.id}`}
                  className={`block rounded-xl border border-slate-800 bg-slate-900/60 p-4 active:scale-[0.99] transition-transform ${
                    isPast ? 'opacity-60' : ''
                  }`}
                >
                  <p className="text-xs uppercase tracking-wide text-slate-500">
                    {e.endAt
                      ? `${formatDate(e.startAt)} – ${formatDate(e.endAt)}`
                      : formatDateTime(e.startAt)}
                  </p>
                  <p className="mt-1 text-base font-semibold truncate">
                    {e.name}
                  </p>
                  <p className="mt-1 text-xs text-slate-400 truncate">
                    {e.location}
                    {e.createdBy
                      ? ` · ${e.createdBy.firstName} ${e.createdBy.lastName}`
                      : ''}
                  </p>
                  {e.description && (
                    <p className="mt-2 text-xs text-slate-400 line-clamp-2">
                      {e.description}
                    </p>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="py-12 text-center text-sm text-slate-400">
          Noch keine Events.
        </p>
      )}
    </div>
  );
}
